<template>
  <v-dialog v-model="control.modalDelete" persistent max-width="50%">
    <v-card>
      <v-card-title class="accent white--text">
        <v-icon color="white">mdi-alert</v-icon> Suppression en cours
      </v-card-title>

      <v-card-text class="body-1">
        <p class="pt-4">
          Vous allez supprimer cet élément (Type : {{ typeObject }} - Id :
          {{ idObject }})
        </p>
        <p v-if="this.typeObject === 'instance' && control.size > 0">
          Attention cette instance comporte {{ control.size }} participants.
        </p>
        <p>
          Êtes-vous sûr de vouloir continuer ?
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="supprimer">
          Oui
        </v-btn>
        <v-btn text @click="annuler">
          Non
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import toasted from '@/utils/toasted';

export default {
  inject: ['control'],
  props: {
    typeObject: {
      type: String,
    },
    idObject: {
      type: Number,
    },
  },
  methods: {
    supprimer() {
      var uri;
      var msg;
      if (this.typeObject === 'contact') {
        uri = `workflow/personne-physique/supprimer/${this.idObject}`;
        msg = 'Contact supprimé';
      } else if (this.typeObject === 'personne morale') {
        uri = `workflow/personne-morale/supprimer/${this.idObject}`;
        msg = 'Personne morale supprimée';
      } else if (this.typeObject === 'instance') {
        uri = `workflow/instance/supprimer/${this.idObject}`;
        msg = 'Instance supprimée';
      }

      return this.$api(uri)
        .post()
        .then(() => {
          toasted.info(msg);
          this.$router.push({ name: 'recherche/recherchesimple' });
        })
        .catch(errors => {
          msg = errors.fieldErrors[0].defaultMessage;
          toasted.error(msg);
        })
        .finally((this.control.modalDelete = false));
    },
    annuler() {
      this.control.modalDelete = false;
    },
  },
};
</script>
